import { useEffect } from 'react';

import { holdReload, ReloadHoldKind } from '../../common/reloadHolds';

/** Holds the reload while `enabled`, and releases it as the component unmounts. */
const useReloadHold = (enabled: boolean, kind = ReloadHoldKind.Work) => {
  useEffect(() => (enabled ? holdReload(kind) : undefined), [enabled, kind]);
};

export default useReloadHold;
